// extracted by mini-css-extract-plugin
export default {"confirmationMessageContainer":"ConfirmationMessage_confirmationMessageContainer__I-UIv","closeButton":"ConfirmationMessage_closeButton__PgUR+"};